export namespace AccountAuthEnum {
  export namespace NICE {
    export enum AUTH_CODE {
      MOBILE = 'MOBILE',
      CARD = 'CARD',
      CERTIFICATE = 'CERTIFICATE',
      I_PIN = 'I_PIN'
    }

    export enum GENDER_CODE {
      MAN = 'MAN',
      WOMAN = 'WOMAN',
      UNKNOWN = 'UNKNOWN'
    }

    export enum NATIONAL_CODE {
      INTERNAL = 'INTERNAL',
      EXTERNAL = 'EXTERNAL'
    }
  }

  export namespace SMS {
    export enum KIND_CODE {
      CREATE_ACCOUNT_AUTH = 'CREATE_ACCOUNT_AUTH',
      FIND_IDENTIFIER = 'FIND_IDENTIFIER',
      FIND_PASSWORD = 'FIND_PASSWORD'
    }

    export enum VERIFY_CODE {
      RANDOM_STRING = 'RANDOM_STRING',
      RANDOM_NUMBER = 'RANDOM_NUMBER'
    }

    export enum VALID_CODE {
      TIME_OUT = 'TIME_OUT',
      CODE_MATCH = 'CODE_MATCH',
      CODE_MISS_MATCH = 'CODE_MISS_MATCH'
    }
  }

  export namespace EMAIL {
    export enum KIND_CODE {
      FIND_IDENTIFIER = 'FIND_IDENTIFIER',
      FIND_PASSWORD = 'FIND_PASSWORD'
    }

    export enum VERIFY_CODE {
      RANDOM_STRING = 'RANDOM_STRING',
      RANDOM_NUMBER = 'RANDOM_NUMBER'
    }

    export enum VALID_CODE {
      TIME_OUT = 'TIME_OUT',
      CODE_MATCH = 'CODE_MATCH',
      CODE_MISS_MATCH = 'CODE_MISS_MATCH'
    }
  }
}
